<div class="progress-bar-container" [class.text-inside]="variant() === 'text-inside'">
  <div class="progress-bar-fill" [style.width.%]="percentage()"></div>
  @if (variant() === 'text-inside') {
    <span class="progress-bar-text">
      <ng-content></ng-content>
    </span>
  }
</div>
